import { getNodeCardId } from 'app/src/components/BoardListView/getListCardsTreeWalker';
import { CARD_ID_ATTRIBUTE } from 'app/src/components/CardFront/CardFront.constants';

/**
 * Given x/y coordinates in a viewport, find a card element and return its ID.
 */
export const getCardIdFromPoint = (x: number, y: number) => {
  const elementFromPoint = document.elementFromPoint(x, y);
  const listCardElement = elementFromPoint?.closest(`[${CARD_ID_ATTRIBUTE}]`);
  return getNodeCardId(listCardElement) || null;
};
